import { ApiService } from '../../services'
import {setUserData, getUserData} from '../../helpers'
export const CartModule = {
    namespaced: true,
    state: {

        loading: false,
        cart: [],
        count: 0,
        total: 0,
        request: null,
        postLoading : false,
        getLoading : false,
        updateLoading : false,
        deleteLoading : false,
        createCartLoading : false,
        cartData : null
    },
    actions: {

        async getCart({ state, commit, rootState  }, params = {}) {
            const configParams = {
                req : "CartModule/req",
                loadingTrue : "CartModule/getLoadingTrue",
                addRequest : "CartModule/addRequest",
                cancelRequest : "CartModule/cancelRequest",
                clearOldRequest : "CartModule/clearOldRequest"
            }
            return await new Promise((resolve, reject) => {
                const { getLoading } = state
                if (!getLoading) {
                    commit('getLoadingTrue')
                    let nlUser = getUserData();            
                    ApiService.get(`cart/${nlUser.cartData.cartKey}`, params, configParams).then((response) => {
                        const cartData = response.data.data.map((item) => {
                            return {
                                ...item
                            }
                        },[])

                        
                        const products = rootState.ProductModule.products;
                        
                        const existingCart = cartData.map((i) => { return i.ItemCode },[])
                        if (products && products.length > 0) {
                            const newProducts = products.map((i) => {
                                i.selected = existingCart.includes(i.ItemCode);
                                return i
                            },[]);
                            commit('ProductModule/setProducts', newProducts, { root: true })
                        }

                        console.log("products",products)

                        commit('setCart', cartData)
                        commit('getLoadingFalse')
                        resolve(response.data.data);
                    }).catch(error => {
                        commit('getLoadingFalse')
                        commit('clearOldRequest')
                        reject(error)
                    })
                }
            })
        },

        async placeOrder({state,commit, dispatch}, payload) {
            const configParams = {
                req : "CartModule/req",
                loadingTrue : "CartModule/loadingTrue",
                addRequest : "CartModule/addRequest",
                cancelRequest : "CartModule/cancelRequest",
                clearOldRequest : "CartModule/clearOldRequest"
            }
            return await new Promise((resolve,reject) => {
                const loading = state.loading;
                if (!loading) {
                    commit('loadingTrue')
                    let user = getUserData();
                    ApiService.post(`cart/${user.cartData.cartKey}/place-order`,payload, configParams).then((response) => {
                        commit('loadingFalse')
                        resolve(response.data)
                        dispatch('getCart')
                    }).catch((error) => {
                        commit('loadingFalse')
                        reject(error)
                    })
                }
            })
        },
        async addToCart({state,commit, dispatch}, payload) {

            const configParams = {
                req : "CartModule/req",
                loadingTrue : "CartModule/postLoadingTrue",
                addRequest : "CartModule/addRequest",
                cancelRequest : "CartModule/cancelRequest",
                clearOldRequest : "CartModule/clearOldRequest"
            }

            return await new Promise((resolve,reject) => {
                const loading = state.postLoading;
                if (!loading) {
                    commit('postLoadingTrue')

                    const cart = {
                        ...payload,
                        Quantity : 1,
                        Price : (payload.Price) ? payload.Price : 0,
                        U_imgURL : payload.U_imgURL.replace(/\/(large|small)-/, "/thumb-")
                    }
                    let nlUser = getUserData();     
                    console.log("cart",nlUser.cartData.cartKey)     
                    ApiService.post(`cart/${nlUser.cartData.cartKey}`,cart, configParams).then((response) => {

                        console.log("response",response)
                        commit('postLoadingFalse')
                        resolve(response.data)
                        dispatch('getCart')
                    }).catch((error) => {
                        commit('postLoadingFalse')
                        reject(error)
                    })
                }
            })
        },
        async updateCart({state,commit, dispatch}, payload) {

            const configParams = {
                req : "CartModule/req",
                loadingTrue : "CartModule/updateLoadingTrue",
                addRequest : "CartModule/addRequest",
                cancelRequest : "CartModule/cancelRequest",
                clearOldRequest : "CartModule/clearOldRequest"
            }
            return await new Promise((resolve,reject) => {
                const {updateLoading} = state;
                if (!updateLoading) {
                    commit('updateLoadingTrue')

                    const cart = {
                        ...payload,
                        Price : (payload.Price) ? payload.Price : 0,
                        U_imgURL : payload.U_imgURL.replace(/\/(large|small)-/, "/thumb-")
                    }

                    let nlUser = getUserData();     
                    ApiService.update(`cart/${nlUser.cartData.cartKey}`,cart,configParams).then((response) => {
                        commit('updateLoadingFalse')
                        resolve(response)
                        dispatch('getCart')
                    }).catch((error) => {
                        commit('updateLoadingFalse')
                        reject(error)
                    })
                }
            })
        },
        async deleteItem({state,commit, dispatch}, payload) {
            return await new Promise((resolve,reject) => {
                const loading = state.deleteLoading;
                const cart = state.cart;
                if (!loading) {
                    commit('deleteLoadingTrue')
                    let nlUser = getUserData(); 

                    const getCartItem = cart.filter(item => item.ItemCode == payload.ItemCode,[]);
                    if(getCartItem.length > 0){
                        const cartItem = getCartItem[0];
                        ApiService.delete(`cart/${nlUser.cartData.cartKey}`,cartItem).then((response) => {
                            commit('deleteLoadingFalse')
                            commit('setCart',cart.filter(item => item.ItemCode !== payload.ItemCode,[]))
                            resolve(response.data)
                            console.log("Success",response)
                            dispatch('getCart')
                        }).catch((error) => {
                            commit('deleteLoadingFalse')
                            reject(error)
                        })
                    }   
                    

                    
                   /*  ApiService.delete(`cart/${nlUser.cartData.cartKey}`,payload).then((response) => {
                        commit('deleteLoadingFalse')
                        commit('cart',cart.filter(item => item.ItemCode !== payload.ItemCode,[]))
                        resolve(response.data)
                        console.log("Success",response)
                        dispatch('getCart')
                    }).catch((error) => {
                        commit('deleteLoadingFalse')
                        reject(error)
                    }) */
                }
            })
        },

        async createCart({ state, commit }) {
            return await new Promise((resolve, reject) => {
                const loading = state.createCartLoading;
                if (!loading) {
                    commit('createCartLoadingTrue')
                    let nlUser = getUserData();
                    
                    let cartData = null;
                    if (nlUser && nlUser.cartData) {
                        cartData = nlUser.cartData;
                    }

                    const configParams = {
                        req : "CartModule/req",
                        loadingTrue : "CartModule/createCartLoadingTrue",
                        addRequest : "CartModule/addRequest",
                        cancelRequest : "CartModule/cancelRequest",
                        clearOldRequest : "CartModule/clearOldRequest"
                    }

                    ApiService.post('cart/create',{...cartData},configParams).then((response) => {
                        commit('createCartLoadingFalse')
                        setUserData(response.data.data);
                        commit('setCart', [])
                        resolve(response.data)
                    }).catch((error) => {
                        commit('createCartLoadingFalse')
                        reject(error)
                    })
                }
            })
        },
        
        async removeItem({ state, commit,dispatch }, payload) {
            return await new Promise((resolve, reject) => {
                const loading = state.deleteLoading;
                if (!loading) {
                    commit('loadingTrue')
                    ApiService.post('cart-remove-item',payload).then((response) => {
                        commit('loadingFalse')
                        dispatch('getCart')
                        resolve(response.data)
                    }).catch((error) => {
                        commit('loadingFalse')
                        reject(error)
                    })
                }
            })
        },
        async reduceByOne({ state, commit,dispatch }, payload) {
            return await new Promise((resolve, reject) => {
                const loading = state.loading;
                if (!loading) {
                    commit('loadingTrue')
                    ApiService.post('cart-reduce-one',payload).then((response) => {
                        commit('loadingFalse')
                        dispatch('getCart')
                        resolve(response.data)
                    }).catch((error) => {
                        commit('loadingFalse')
                        reject(error)
                    })
                }
            })
        },

        async clear({ state, commit,dispatch }) {
            return await new Promise((resolve, reject) => {
                const loading = state.loading;
                if (!loading) {
                    commit('loadingTrue')
                    ApiService.post('cart-clear',{}).then((response) => {
                        commit('loadingFalse')
                        dispatch('getCart')
                        resolve(response.data)
                    }).catch((error) => {
                        commit('loadingFalse')
                        reject(error)
                    })
                }
            })
        },


        async getCartData() {
            return await new Promise((resolve) => {
                resolve(getUserData().cartData)
            })
        },
        

    },
    mutations: {
        loadingFalse: (state) => {
            state.loading = false
        },
        loadingTrue: (state) => {
            state.loading = true
        },
        setCart: (state, payload) => {
            state.cart = payload
        },
        setCartItemCount: (state, payload) => {
            state.count = payload
        },
        setTotal: (state, payload) => {
            state.total = payload
        },

        addRequest : (state, req) => {
            state.request = {cancel : req.cancel, msg : "loading"}

        },
        cancelRequest : (state) => {

            if(state.request != null){
                state.request.cancel()
            }
            state.loading = true
        },
        clearOldRequest(state, message) {
            state.request.msg = message;
            state.request = null;
        },

        setPostLoading : (state, payload) => {
            state.postLoading = payload
        },
        postLoadingTrue : (state) => {
            state.postLoading = true
        },
        postLoadingFalse : (state) => {
            state.postLoading = false
        },
        getLoadingTrue : (state) => {
            state.getLoading = true
        },
        getLoadingFalse : (state) => {
            state.getLoading = false
        },
        updateLoadingTrue : (state) => {
            state.updateLoading = true
        },
        updateLoadingFalse : (state) => {
            state.updateLoading = false
        },
        deleteLoadingTrue : (state) => {
            state.deleteLoading = true
        },
        deleteLoadingFalse : (state) => {
            state.deleteLoading = false
        },
        createCartLoadingTrue : (state) => {
            state.createCartLoading = true
        },
        createCartLoadingFalse : (state) => {
            state.createCartLoading = false
        },

        setCartData : (state, payload) => {
            state.cartData = payload
        }

    },
    getters: {
        req: state => state.request,
        cart: state => state.cart,
        loading: state => state.loading,
        count: state => state.count,
        total: state => state.total,
        postLoading: state => state.postLoading,
        getLoading: state => state.getLoading,
        updateLoading: state => state.updateLoading,
        deleteLoading: state => state.deleteLoading,
        createCartLoading: state => state.createCartLoading,
        cartData: state => state.cartData
    }
}
